import { useSelectedFormContext } from "../../../../../context/SelectedForm/selected-form-context";
import { useEffect, useMemo, useState } from "react";
import {
  getSelectedFormDataHelper,
  getSelectedFormEntryDataHelper,
  saveFormHelper,
} from "../../../../../context/SelectedForm/selected-form-context.helper";
import {
  IFormEntryModel,
} from "../../../../../interfaces/form-entry.interface";
import {
  IFormFiledInterface,
} from "../../../../../interfaces/form-filed.interface";
import { useNavigate } from "react-router-dom";
import {
  IFormSettingModel,
} from "../../../../../interfaces/form-settings.interface";
import { Dialog } from "@progress/kendo-react-dialogs";
import { SelectedFormActionsEnum } from "../../../../../context/SelectedForm/selected-form-actions";
import { useFormContext } from "../../../../../context/Form/form-context";
import {
  onLoadForms
} from "../../../../../context/Form/form-helper";
import { CustomLoader } from "../../../../../components";
import { FormActionsEnum } from "../../../../../context/Form/form-actions";
import { useCallbackPrompt } from "../../../../../hooks/useCallbackPrompt";
import UnsavedFormDialog from "../../../../../components/CustomDialogs/UnsavedFormDialog/UnsavedFormDialog";
import { t } from "i18next";
import { AddressChangeFormName } from "../../../../../constants/form-names-constants";
import AddressChangeFormFirstSection from "./AddressChangeFormFirstSection";
import AddressChangeFormFourthSection from "./AddressChangeFormFourthSection";
import AddressChangeFormFifthSection from "./AddressChangeFormFifthSection";
import AddressChangeFormThirdSection from "./AddressChangeFormThirdSection";
import AddressChangeFormSecondSection from "./AddressChangeFormSecondSection";
import AuthService from "../../../../../services/authentication.service";
import { useFormSectionDataFields } from "../useFormSectionDataFields";
import { AddressChangeFormFirstSectionInitialState, IAddressChangeFormFirstSection } from "../../../../../interfaces/forms/AddressChangeForm/address-change-form-first-section.interface";
import { AddressChangeFormSecondSectionInitialState, IAddressChangeFormSecondSection } from "../../../../../interfaces/forms/AddressChangeForm/address-change-form-second-section.interface";
import { AddressChangeFormThirdSectionInitialState, IAddressChangeFormThirdSection } from "../../../../../interfaces/forms/AddressChangeForm/address-change-form-third-section.interface";
import { AddressChangeFormFourthSectionInitialState, IAddressChangeFormFourthSection } from "../../../../../interfaces/forms/AddressChangeForm/address-change-form-fourth-section.interface";
import { AddressChangeFormFifthSectionInitialState, IAddressChangeFormFifthSection } from "../../../../../interfaces/forms/AddressChangeForm/address-change-form-fifth-section.interface";
import classes from "./AddressChangeForm.module.scss";
import AddressChangeFormPDFView from "src/pages/Shared/AddressChangeFormPDFView/AddressChangeFormPDFView";
import { FormHeader } from "../Shared/FormHeader/FormHeader";
import { submitted } from "src/constants/submission-form-status-constants";
import { AddressChangeDisclaimer } from "./AddressChangeDisclaimer";

interface FormEntry {
  formEntryId?: number;
  isAdminPreview?: boolean;
  formId?: number;
}

export default function AddressChangeForm(props: FormEntry): JSX.Element {
    const { isAuthorized } = AuthService.getInstance();

    const { isAdminPreview, formEntryId, formId } = props;
    const { formState, formDispatch } = useFormContext();
    const { selectedFormDispatch, selectedFormState } = useSelectedFormContext();
    const { loading } = formState;
    const { isLoading } = selectedFormState;
    const [formDataFields, setFormDataFields] = useState<Array<IFormFiledInterface>>();
    const [formEntry, setFormEntry] = useState<IFormEntryModel>();
    const formSettings = useMemo(() => {
      let formSettings = selectedFormState.formSettings ?? undefined;
      if (
          !isAuthorized ||
          isAdminPreview ||
          selectedFormState.formEntry?.submissionStatus == submitted
       ) {
        formSettings = { ...formSettings, isReadOnly: true };
       }
       return formSettings;
    }, [selectedFormState.formSettings, selectedFormState.formEntry, isAuthorized, isAdminPreview]);
    const [showPrompt, confirmNavigation, cancelNavigation, setDisablePrompt] = useCallbackPrompt(!!(isAuthorized && !isAdminPreview && !formSettings?.isReadOnly));

    const [formFirstSectionDataFields, setFormFirstSectionDataFields] = useState<IAddressChangeFormFirstSection>();
    const [formSecondSectionDataFields, setFormSecondSectionDataFields] = useState<IAddressChangeFormSecondSection>();
    const [formThirdSectionDataFields, setFormThirdSectionDataFields] = useState<IAddressChangeFormThirdSection>();
    const [formFourthSectionDataFields, setFormFourthSectionDataFields] = useState<IAddressChangeFormFourthSection>();
    const [formFifthSectionDataFields, setFormFifthSectionDataFields] = useState<IAddressChangeFormFifthSection>();
    const [firstSectionIsValid, setFirstSectionIsValid] = useState<boolean>(false);
    const [secondSectionIsValid, setSecondSectionIsValid] = useState<boolean>(false);
    const [thirdSectionIsValid, setThirdSectionIsValid] = useState<boolean>(false);
    const [fourthSectionIsValid, setFourthSectionIsValid] = useState<boolean>(false);
    const [fifthSectionIsValid, setFifthSectionIsValid] = useState<boolean>(false);
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [showDisclaimer, setShowDisclaimer] = useState(false);

    useEffect(() => {
      setIsFormValid(
        firstSectionIsValid &&
        secondSectionIsValid &&
        thirdSectionIsValid &&
        fourthSectionIsValid &&
        fifthSectionIsValid)
    }, [
      firstSectionIsValid,
      secondSectionIsValid,
      thirdSectionIsValid,
      fourthSectionIsValid,
      fifthSectionIsValid])

    useEffect(() => {
      return () => {
        selectedFormDispatch({
          type: SelectedFormActionsEnum.CLEAR,
          payload: {
            errorMessage: undefined,
            isLoading: undefined,
            formFields: undefined,
            successMessage: undefined,
            form: undefined,
            formSettings: undefined,
            formEntry: undefined,
            status: SelectedFormActionsEnum.CLEAR
          },
        });
      }
    }, []);

    useEffect(() => {
      const disclaimerFormText = formState.forms?.find(x => x.name === AddressChangeFormName)?.disclaimerText ?? "";
      if (!formEntryId && disclaimerFormText.trim().length > 0) {
        setShowDisclaimer(true);
      }
    }, [formEntryId, formState?.forms]);

    useEffect(() => {
      if (!formState.forms.length) {
        onLoadForms(formDispatch);
      }
    }, []);

    useEffect(() => {
      const stateFormId = formState?.forms?.find(x => x.name == AddressChangeFormName)?.id ?? formId;

      if (stateFormId && isAuthorized) {
        if (formEntryId) {
          getSelectedFormEntryDataHelper(selectedFormDispatch, stateFormId, formEntryId);
        } else {
          getSelectedFormDataHelper(selectedFormDispatch, stateFormId);
        }
      }
    }, [formState.forms]);

    useEffect(() => {
      if (selectedFormState?.formEntry) {
        if (selectedFormState.form?.name) {
          setFormEntry({
            ...selectedFormState?.formEntry,
            formName: selectedFormState.form?.name
          });
        } else {
          setFormEntry(selectedFormState.formEntry)
        }
      }
    }, [selectedFormState.formEntry, selectedFormState.form]);

    function ClearData() {
      setFormDataFields([]);
      setFormEntry(undefined);
      setFormFirstSectionDataFields({});
      setFormSecondSectionDataFields({});
      setFormThirdSectionDataFields({});
      setFormFourthSectionDataFields({});
      setFormFifthSectionDataFields({});
      setFirstSectionIsValid(false);
      setSecondSectionIsValid(false);
      setThirdSectionIsValid(false);
      setFourthSectionIsValid(false);
      setFifthSectionIsValid(false);

      setDisablePrompt(false);
    }

    useEffect(() => {
      if (selectedFormState.status === SelectedFormActionsEnum.CLEAR) {
        ClearData();
        return;
      }

      setFormDataFields(selectedFormState.formFields);
      const FirstSection: IAddressChangeFormFirstSection = AddressChangeFormFirstSectionInitialState();
      const SecondSection: IAddressChangeFormSecondSection = AddressChangeFormSecondSectionInitialState();
      const ThirdSection: IAddressChangeFormThirdSection = AddressChangeFormThirdSectionInitialState();
      const FourthSection: IAddressChangeFormFourthSection = AddressChangeFormFourthSectionInitialState();
      const FifthSection: IAddressChangeFormFifthSection = AddressChangeFormFifthSectionInitialState();

      selectedFormState?.formFields.forEach((f) => {
        let value;
        switch (f.type) {
          case "boolean":
          case "object":
            value = JSON.parse(f.value);
            break;
          case "string":
            value = f.value.trim();
            break;
          case "number":
            value = +f.value;
            break;
        }

        switch(true) {
          case f.name in FirstSection:
            (FirstSection as any)[f.name] = value;
            break;
          case f.name in SecondSection:
            (SecondSection as any)[f.name] = value;
            break;
          case f.name in ThirdSection:
            (ThirdSection as any)[f.name] = value;
            break;
          case f.name in FourthSection:
            (FourthSection as any)[f.name] = value;
            break;
          case f.name in FifthSection:
            (FifthSection as any)[f.name] = value;
            break;
        }
      });
      if (selectedFormState.formFields.length > 0) {
        setFormFirstSectionDataFields(FirstSection);
        setFormSecondSectionDataFields(SecondSection);
        setFormThirdSectionDataFields(ThirdSection);
        setFormFourthSectionDataFields(FourthSection);
        setFormFifthSectionDataFields(FifthSection);
      }
    }, [selectedFormState.formFields]);

    useFormSectionDataFields({
      sectionFields: formFirstSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formSecondSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formThirdSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formFourthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formFifthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    const navigate = useNavigate();

    function saveHandler() {
      setDisablePrompt(true);
      const temp = {
        ...formEntry,
        formName: selectedFormState.form?.name,
        submissionStatus: "Saved",
      } as IFormEntryModel;
      setFormEntry(temp);
      if (selectedFormState.form?.name) {
        saveFormHelper(selectedFormDispatch, selectedFormState.form?.name, temp, formDataFields!, navigate);
      }
    }

    function setFormEntryBase64Url(url: string) {
      setFormEntry({ ...formEntry, pdfBase64Url: url } as IFormEntryModel);
    }

    function submitHandler() {
      const temp = {
        ...formEntry,
        formName: selectedFormState.form?.name,
        submissionStatus: "Submitted",
      } as IFormEntryModel;
      setFormEntry(temp);
      setDisablePrompt(true);

      if (selectedFormState.form?.name) {
        saveFormHelper(selectedFormDispatch, selectedFormState.form?.name, temp, formDataFields!, navigate);
      }
    }

    const [visible, setVisible] = useState<boolean>(false);
    const [submit, setSubmit] = useState<boolean>(false);

    const toggleDialog = () => {
      setVisible(!visible);
    };

    const toggleSubmitDialog = () => {
      setSubmit(!submit);
      setVisible(!visible);
    };

    const dialogTitle = (
      <div>
        {submit && !formEntry?.underRevision && formEntry?.submissionStatus != "Submitted" && (
          <button className="button" onClick={submitHandler}>
            submit form
          </button>
        )}
      </div>
    );

    return <>
      <div className={classes.form}>
        {visible && (
          <Dialog
            className="customFormDialog"
            title={dialogTitle}
            onClose={submit ? toggleSubmitDialog : toggleDialog}
            width={"70vw"}
            height={"90vh"}
          >
            <AddressChangeFormPDFView
              getPdfBase64Url={setFormEntryBase64Url}
              formDataFieldsFirstSection={formFirstSectionDataFields}
              formDataFieldsSecondSection={formSecondSectionDataFields}
              formDataFieldsThirdSection={formThirdSectionDataFields}
              formDataFieldsFourthSection={formFourthSectionDataFields}
              formDataFieldsFifthSection={formFifthSectionDataFields}
            />
          </Dialog>
        )}

        <FormHeader
          formName={AddressChangeFormName}
          isAdminPreview={isAdminPreview}
          isAuthorized={isAuthorized}
          formEntry={formEntry}
          formSettings={formSettings}
          isFormValid={isFormValid}
          onPrint={() => toggleDialog()}
          onSave={() => saveHandler()}
          onSubmit={() => toggleSubmitDialog()}
        />

        <AddressChangeFormFirstSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formFirstSectionDataFields}
          setFormDataFields={setFormFirstSectionDataFields}
          setFormIsValid={setFirstSectionIsValid}
        />

        <AddressChangeFormSecondSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formSecondSectionDataFields}
          setFormDataFields={setFormSecondSectionDataFields}
          setFormIsValid={setSecondSectionIsValid}
        />

        <AddressChangeFormThirdSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formThirdSectionDataFields}
          setFormDataFields={setFormThirdSectionDataFields}
          setFormIsValid={setThirdSectionIsValid}
        />

        <AddressChangeFormFourthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formFourthSectionDataFields}
          setFormDataFields={setFormFourthSectionDataFields}
          setFormIsValid={setFourthSectionIsValid}
          selectedFormDispatch={selectedFormDispatch}
          formEntry={formEntry}
        />

        <AddressChangeFormFifthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formFifthSectionDataFields}
          setFormDataFields={setFormFifthSectionDataFields}
          setFormIsValid={setFifthSectionIsValid}
        />

        {(!isFormValid && !formSettings?.isReadOnly) &&
          <div className={classes.invalidForm}>
            <h2>Please Fill All Required Fields in Steps:</h2>
            {!firstSectionIsValid &&
              <div className={classes.item}>
                1.   Date Request
              </div>}
            {!secondSectionIsValid &&
              <div className={classes.item}>
                2.   Account Information
              </div>}
            {!thirdSectionIsValid &&
              <div className={classes.item}>
                3.   Mailing Address Information
              </div>}
            {!fourthSectionIsValid &&
              <div className={classes.item}>
                4.   Additional Supporting Documents
              </div>}
            {!fifthSectionIsValid &&
              <div className={classes.item}>
                5.   Certification and Signature
              </div>}
          </div>}

        {isAuthorized && !isAdminPreview &&
          !formSettings?.isReadOnly &&
          formEntry?.submissionStatus != "Submitted" && (
            <span className="buttons-group">
              <button disabled={!isFormValid}
                className="button"
                onClick={() => toggleSubmitDialog()}
              >
                <i className="fa fa-tasks fa-fw"></i>
                Review & Submit
              </button>
            </span>
          )}
      </div>
      {showDisclaimer && (
      <AddressChangeDisclaimer 
          disclaimerText={formState?.forms?.find(x => x.name == AddressChangeFormName)?.disclaimerText?.trim() || ""}
          onClose={() => setShowDisclaimer(false)} />)}
      {(loading || isLoading) && <CustomLoader />}
      {showPrompt && isAuthorized && (!loading && !isLoading) && (
        <UnsavedFormDialog
          onConfirm={confirmNavigation}
          onCancel={cancelNavigation}
        />
      )}
    </>
  }